exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shop/shop-promocodes/shop-promocodes.component.scss
// module id = ../../../../../src/app/shop/shop-promocodes/shop-promocodes.component.scss
// module chunks = main